import SectionTitle from "@/components/base/SectionTitle";

export default function FeatureGrid() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-start justify-between gap-4 mb-12">
          <SectionTitle
            title="Why PandaBuy Spreadsheet?"
            subtitle="What makes this hub different from the rest"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          <div className="bg-background-100 rounded-2xl p-6 md:p-8 flex flex-col">
            <div className="w-14 h-14 rounded-xl bg-accent-100 flex items-center justify-center mb-5">
              <i className="ri-stack-line text-accent-600 text-2xl"></i>
            </div>
            <div className="rounded-xl overflow-hidden mb-5">
              <img
                src="https://readdy.ai/api/search-image?query=Laptop%20screen%20displaying%20colorful%20organized%20spreadsheet%20with%20product%20thumbnails%20on%20a%20wooden%20desk%20with%20coffee%20mug%20and%20notebook%20bright%20coworking%20space%20ambient%20lighting%20modern%20tech%20workspace%20photography%20clean%20crisp%20focus&width=400&height=300&seq=feature-organized-v2&orientation=landscape"
                alt="Organized pandabuyspreadsheet data structure"
                title="Structured PandaBuy Spreadsheet Data"
                className="w-full h-48 object-cover rounded-xl"
                loading="lazy"
              />
            </div>
            <h3 className="text-lg font-semibold text-foreground-950 mb-2">Organized Data</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Unlike messy Reddit threads, our pandabuyspreadsheet is structured into clean,
              searchable categories with quality scores for every item.
            </p>
          </div>

          <div className="bg-background-100 rounded-2xl p-6 md:p-8 flex flex-col">
            <div className="w-14 h-14 rounded-xl bg-primary-100 flex items-center justify-center mb-5">
              <i className="ri-time-line text-primary-600 text-2xl"></i>
            </div>
            <div className="rounded-xl overflow-hidden mb-5">
              <img
                src="https://readdy.ai/api/search-image?query=Wall%20calendar%20with%20red%20circles%20marking%20dates%20and%20a%20stylish%20analog%20desk%20clock%20on%20a%20shelf%20with%20small%20succulent%20plant%20warm%20afternoon%20sunlight%20cozy%20home%20office%20setting%20motivational%20productivity%20concept%20photography&width=400&height=300&seq=feature-daily-v2&orientation=landscape"
                alt="Daily updated pandabuy spreadsheet"
                title="Daily Updated PandaBuy Sheet"
                className="w-full h-48 object-cover rounded-xl"
                loading="lazy"
              />
            </div>
            <h3 className="text-lg font-semibold text-foreground-950 mb-2">Updated Daily</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Our pandabuy sheet is refreshed every day with new finds, so dead links and outdated
              products are a thing of the past.
            </p>
          </div>

          <div className="bg-background-100 rounded-2xl p-6 md:p-8 flex flex-col">
            <div className="w-14 h-14 rounded-xl bg-secondary-200 flex items-center justify-center mb-5">
              <i className="ri-group-line text-secondary-700 text-2xl"></i>
            </div>
            <div className="rounded-xl overflow-hidden mb-5">
              <img
                src="https://readdy.ai/api/search-image?query=Three%20diverse%20friends%20sitting%20around%20a%20table%20looking%20at%20a%20laptop%20and%20laughing%20together%20in%20a%20bright%20modern%20cafe%20with%20large%20windows%20and%20plants%20casual%20social%20gathering%20photography%20warm%20genuine%20interaction%20authentic%20moment&width=400&height=300&seq=feature-community-v2&orientation=landscape"
                alt="Community verified pandabuyspreadsheet"
                title="Community Verified PandaBuy Spreadsheet"
                className="w-full h-48 object-cover rounded-xl"
                loading="lazy"
              />
            </div>
            <h3 className="text-lg font-semibold text-foreground-950 mb-2">Community Verified</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Every pandabuyspreadsheet entry is cross-referenced with real community reviews from
              Reddit, TikTok, and trusted forums.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}